import { styled } from '@mui/material/styles'
import { colorPalette } from '../../../view/style/colorPalette'
import { WbsItemSearchPreview } from './wbsItemSearchPreviews'

const EXAMPLE_LABEL = '表示例'
// 説明文は「WBSの検索画面が開き、〜」と製品版の動きを書いているため、
// デモでは開かないことを表示例の横で断る。ヘッダーの常設案内
// （layout/DemoLimitationNotice.tsx）とは共有せず、他のデモ画面に影響させない。
const DEMO_NAVIGATION_NOTE = '※デモ版のため、検索画面は開きません。'

// どの値を押してもポッパーの大きさが変わらないよう、最も大きくなる場合
// （最長の説明文でWbsItemSearchPreviewTooltipの最大幅360pxまで広がり、2行に
// 折り返す）に揃える。幅は最大幅からTooltipの左右パディング（MUI既定の8pxずつ）
// を引いた値。
const CONTENT_WIDTH = 344
const DESCRIPTION_LINE_HEIGHT = 18
const DESCRIPTION_MAX_LINES = 2

type WbsItemSearchPreviewContentProps = {
  preview: WbsItemSearchPreview
}

const Content = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  gap: '6px',
  padding: '2px 0',
  width: `${CONTENT_WIDTH}px`,
})

const Description = styled('span')({
  color: colorPalette.monotone[10],
  fontSize: '13px',
  lineHeight: `${DESCRIPTION_LINE_HEIGHT}px`,
  minHeight: `${DESCRIPTION_LINE_HEIGHT * DESCRIPTION_MAX_LINES}px`,
})

const ExampleHeader = styled('div')({
  display: 'flex',
  alignItems: 'baseline',
  gap: '8px',
  fontSize: '11px',
})

const ExampleImage = styled('img')({
  display: 'block',
  maxWidth: '100%',
  border: `1px solid ${colorPalette.monotone[2]}`,
  borderRadius: '4px',
})

export const WbsItemSearchPreviewContent = ({
  preview: { description, image },
}: WbsItemSearchPreviewContentProps) => {
  return (
    <Content>
      <Description>{description}</Description>
      <ExampleHeader>
        <span>{EXAMPLE_LABEL}</span>
        <span>{DEMO_NAVIGATION_NOTE}</span>
      </ExampleHeader>
      <ExampleImage src={image} alt={EXAMPLE_LABEL} />
    </Content>
  )
}
